module.exports = __webpack_public_path__ + "img/ad3.54206153.jpg";